import { PocExpandable } from 'commons/components/components-wrapper';
import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';
import { placeholderTextStyle } from 'commons/styles/placeholder-text.style';
import { TooltipedTextComponent } from '../tooltiped-text';

export const StyledExpandable = styled(PocExpandable)`
    width: 100%;

    /* v6 parity: native expandable is 4px, the old owc-card was 16px. */
    && {
        border-radius: ${owcTheme['one-border-radius-16']};
    }

    /*
     * OWC-OVERRIDE: v6 parity — restore the card's 24px padding (native uses 8px) and a fixed
     * 64px header. Left padding subtracts the slotted title's own 8px margin
     * (one-spacing-gap-4-xs) so the title lines up with the content edge.
     * owc-expandable exposes no control-height or control-padding prop in v7.6.0; '&&' raises
     * specificity above owc's ':host >' rule. Revisit on the next @one upgrade.
     */
    && .owc-expandable__control-wrapper {
        height: ${owcTheme['one-spacing-size-3-xl']};
        padding-right: ${owcTheme['one-spacing-padding-s']};
        padding-left: calc(${owcTheme['one-spacing-padding-s']} - ${owcTheme['one-spacing-gap-4-xs']});
    }

    /*
     * workflow-overlay styles its own 'div[slot=content]' (flex row, overflow hidden), and that
     * rule leaks into this card's identically-named slot, laying sections out horizontally.
     * Restore pre-v7 stacking and padding; '&&&' outranks the leak and the native ::slotted rule.
     */
    &&& [slot='content'] {
        display: block;
        height: auto;
        padding-right: ${owcTheme['one-spacing-padding-s']};
        padding-left: ${owcTheme['one-spacing-padding-s']};
        overflow: visible;
    }
`;

export const CollapsibleCardTitleTooltipedTextStyled = styled(TooltipedTextComponent)<{ $isPlaceholder?: boolean }>`
    font-size: 20px;
    font-style: normal;

    ${({ $isPlaceholder }) => $isPlaceholder && placeholderTextStyle}
`;
